<template>
  <b-list-group-item
      :variant="!item.Disabled ? null : 'warning'"
      :href="`#/job/${item.id}`"
  >
    <h5 class="mb-1">
      <mdi-icon icon="briefcase-check" class="text-muted"/>
      {{ item.Description }}
      <small class="text-muted ml-2">
        {{ item?.GroupCode?.GroupCode }}
      </small>
      <b-badge
          class="float-right"
          :variant="!item.Disabled?null:'warning'"
      >
        <b-icon
            title="Disabilitato"
            class="mr-1"
            icon="bookmark-x-fill"
            v-if="item.Disabled"
        />
        {{ item.Job }}
      </b-badge>
    </h5>

  </b-list-group-item>
</template>

<script>
export default {
  name: "JobItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    term: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped></style>
